export enum ShipmentStatusCategoryStrings {
  "READY" = "READY",
  "TO_FIX" = "TO_FIX",
  "COMPLETE" = "COMPLETE",
  "CANCELLED" = "CANCELLED",
}
